<template>
  <div :id="claim.id" class="list-box-container"
       @mouseup="($_can('claims.show') ||
         $_can('claims.view-own'))"
  >
    <template v-if="claimLoading">
      <div class="lds-ellipsis px-4 py-4">
        <div />
        <div />
        <div />
      </div>
    </template>
    <template v-else>
      <router-link :to="{ name: 'ClaimsEdit', params: { id: `${claim.id}`}}">
        <div class="d-flex list-box-header col-12">
          <div class="list-box-header-left-no-justify col-lg-8 col-md-8">
            <div class="pl-0 d-flex align-items-center col-lg-2 col-3 pointer" @mousemove="visible = true" @mouseleave="visible = false">
              <div class="list-box-status align-items-start">
                <span class="ref-id pointer">
                  {{ claim.ref_id }}
                </span>
                <template v-if="claim.status">
                  <span v-if="claim.status === 'New'" :class="'btn-status btn-new'">{{ claim.status }}</span>
                  <span v-if="claim.status === 'Active'" :class="'btn-status btn-active'">{{ claim.status }}</span>
                  <span v-if="claim.status === 'Closed'" :class="'btn-status btn-closed'">{{ claim.status }}</span>
                  <span v-if="claim.status === 'Reopened'" :class="'btn-status btn-active'">{{ claim.status }}</span>
                </template>
              </div>
              <i
                v-if="visible"
                class="fa fa-copy list-box-icon copy-icon pointer"
                @click.prevent.stop="copyToClipboard(claim.ref_id, 'Successfully copied to clipboard')"
                @mousemove="visible = true" @mouseleave="visible = false"
              />
            </div>
            <div class="d-flex align-items-center col-lg-4 col-8 wrap pointer">
              {{ claim.customer.name }}
            </div>
            <div class="d-flex align-items-center claim-move-date col-3 company-wrap wrap pointer">
              <div class="claim-moving-company pr-4">
                {{ claim.company }}
              </div>
            </div>
            <label />
            <div class="d-flex align-items-center claim-move-date company-wrap pl-3 col-2 wrap pointer">
              <customTooltip :config="{ placement: 'top' }">
                <div
                  slot-scope="{ isOpen, open, close }"
                  @mouseover="open"
                  @mouseleave="close"
                >
                  <span data-trigger>
                    {{ claim.date }}
                  </span>
                  <div
                    v-show="isOpen"
                    data-popper
                    class="custom-tooltip"
                  >
                    <div
                      x-arrow
                      class="border-black"
                    />
                    Created date
                  </div>
                </div>
              </customTooltip>
            </div>
            <div class="d-flex align-items-center col-2 pr-4 wrap pointer">
              <label />
              <customTooltip :config="{ placement: 'top' }">
                <div
                  slot-scope="{ isOpen, open, close }"
                  @mouseover="open"
                  @mouseleave="close"
                >
                  <div class="claim-agent" v-if="claim.cluster_user" data-trigger>
                    {{ claim.cluster_user.username }}
                  </div>
                  <div class="claim-agent" v-else data-trigger>
                    <i class="fa fa-exclamation-circle unassigned-icon" />
                    <span>
                      Unassigned
                    </span>
                  </div>
                  <div
                    v-show="isOpen"
                    data-popper
                    class="custom-tooltip"
                  >
                    <div
                      x-arrow
                      class="border-black"
                    />
                    Assignee
                  </div>
                </div>
              </customTooltip>
            </div>
          </div>
          <div class="list-box-header-right col-4">
            <div class="list-box-header-options justify-content-end col-12">
              <div class="d-flex align-items-center wrap pointer">
                <div class="claim-trucks-movers">
                  <i class="fa fa-user list-box-icon" />
                  <span class="price-value pr-2">
                    {{ claim.movers }}
                  </span>
                  <i class="fa fa-truck list-box-icon" />
                  <span class="price-value">
                    {{ claim.trucks }}
                  </span>
                </div>
                <label />
                <customTooltip :config="{ placement: 'top' }">
                  <div
                    slot-scope="{ isOpen, open, close }"
                    @mouseover="open"
                    @mouseleave="close"
                  >
                    <div class="price pl-3 pr-4" data-trigger>
                      ${{ claim.total_price }}
                    </div>
                    <div
                      v-show="isOpen"
                      data-popper
                      class="custom-tooltip"
                    >
                      <div
                        x-arrow
                        class="border-black"
                      />
                      Total move price
                    </div>
                  </div>
                </customTooltip>
              </div>
              <div class="options">
                <div class="options-buttons">
                  <div class="dropdown" @click.prevent>
                    <button type="button" class="btn btn-secondary add-filter" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false"
                    />
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item nav-link btn" @click="assignClaim">
                        Assign user
                      </button>
                      <button class="dropdown-item nav-link btn" v-if="claim.status !== 'Closed'" @click="claimClose = true">
                        Close claim
                      </button>
                    </div>
                  </div>
                  <button class="btn btn-secondary expand-claims" @click.prevent.stop="toggleClaim(claim.id)">
                    <i class="fa fa-caret-down caret" :class="{ rotate: expanded.includes(claim.id) }" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
      <hr :class="[expanded.includes(claim.id) ? 'w-100 divider' : 'hidden']" />
      <div class="d-flex flex-column" :class="[expanded.includes(claim.id) ? 'list-box-expanded' : 'hidden']">
        <div class="d-flex col-12 p-0">
          <div class="d-flex flex-column justify-content-start col-lg-3 contact-info-wrap">
            <div class="contact-info mb-4">
              <span class="claim-heading pb-2">
                Contact info
              </span>
              <span class="email">
                <i class="fa fa-at list-box-icon" />
                {{ claim.customer.email }}
              </span>
              <span class="phone">
                <i class="fa fa-phone list-box-icon" />
                {{ phoneMask.maskedPhone(claim.customer.phone) }}
              </span>
            </div>
            <!--          <div class="send-email pointer">-->
            <!--            <i class="fa fa-envelope list-box-icon pr-2" /> Send email-->
            <!--          </div>-->
          </div>
          <div class="d-flex flex-column justify-content-start col-lg-5 col-6">
            <div class="list-box-info mb-4">
              <span class="claim-title pb-1">
                {{ claim.title }}
              </span>
              <span>
                {{ claim.description }}
              </span>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-start col-lg-1 col-6 pl-2">
            <div class="list-box-info mb-4">
              <span class="claim-heading pb-1">
                Move date
              </span>
              <span>
                {{ claim.move_date }}
              </span>
              <template v-if="$_can('tags.show')">
                <span class="claim-heading pt-3">
                  Tags
                </span>
                <div class="d-flex align-items-center justify-content-start flex-wrap pt-2">
                  <tag-color v-for="tag in claim.tags" :key="tag.id" :color="tag.color.name" :name="tag.name" input-class="mr-1" />
                </div>
              </template>
            </div>
          </div>
          <ClaimsBlockSettlementAmount
            :claim="claim"
            @update="$emit('getClaims')"
          />
        </div>
        <div class="claim-expanded-mobile col-12 mobileshow pl-0">
          <div class="flex-column justify-content-start col-6">
            <div class="list-box-info mb-4">
              <span class="claim-heading pb-1">
                Assigned to
              </span>
              <span v-if="claim.cluster_user">
                {{ claim.cluster_user.name }}
              </span>
              <span v-else>
                System
              </span>
              <span class="claim-heading pt-3">
                Created by
              </span>
              <span v-if="claim.created_by">
                {{ claim.created_by.first_name }} {{ claim.created_by.last_name }}
              </span>
              <span v-else>
                System
              </span>
              <span class="claim-heading pt-3">
                Move date
              </span>
              <span>
                {{ claim.move_date }}
              </span>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-start col-6">
            <div class="list-box-info mb-4">
              <span class="claim-heading pb-1">
                Company
              </span>
              <span>
                {{ claim.company }}
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-start col-12" v-if="claim.status === 'Closed'">
          <div class="claim-closed justify-content-between col-lg-5 col-12">
            <div class="d-flex mb-2 pr-3">
              <p>Claim closed with resolution <b>{{ claim.claim_resolution }}</b></p>
            </div>
            <div class="d-flex pointer justify-content-end" @click="reopenClaim">
              <i class="fa fa-repeat reopen-ico pr-2" />
              <span class="reopen-text">Reopen claim</span>
            </div>
          </div>
        </div>
      </div>

      <!--  Claim resolution modal   -->
      <modal v-if="claimClose" @close="claimClose = false" :size="'modal-large'"
             :close-strict="true"
      >
        <div slot="header">
          <h4>{{ claim.ref_id }} - Close claim</h4>
        </div>
        <div slot="body">
          <div class="select-wrap">
            <label>Select a resolution</label>
            <simple-select
              v-if="claim"
              :options="claimResolutions"
              v-model="claim_resolution_id"
            />
          </div>

          <error-field :errors="errors" field="claim_resolution_id" />

          <div class="select-wrap h-auto mt-3">
            <label>Enter a note</label>
            <textarea class="select-wrap-textarea form-control" rows="5" v-model="note" required />
          </div>
          <error-field :errors="errors" field="note" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12 text-right">
              <button class="btn btn-secondary" type="button" @click="claimClose = false">Cancel</button>
              <button type="button" class="btn btn-primary" :disabled="formInvalid" @click="claimResolution">Close claim</button>
            </div>
          </div>
        </div>
      </modal>
      <!-- Claim assign modal   -->
      <modal v-if="showAssignClaim"
             @close="showAssignClaim = false"
             :size="'modal-large'"
             :close-strict="true"
      >
        <div slot="header">
          <div class="row">
            <div class="col-10">
              <div>
                <h4>{{ claim.ref_id }} - Assign claim to</h4>
              </div>
            </div>
          </div>
        </div>
        <div slot="body">
          <div class="select-wrap">
            <label>Select User</label>
            <simple-select v-model="assigneeId"
                           :options="assignees"
                           @change="clearError($event)"
            />
          </div>
          <error-field :errors="errors" field="cluster_user_id" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12">
              <button type="button"
                      class="btn btn-primary pull-right"
                      @click="assign"
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      </modal>
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import toastr from 'toastr';
import PhoneMask from '../../classes/PhoneMask';
import ClaimsBlockSettlementAmount from './ClaimsBlockSettlementAmount';
import customTooltip from '../CustomTooltip';
import Modal from '../Modal';
import Errors from '../../classes/Errors';
import TagColor from '../settings/Tags/TagColor';

export default {
  components: {
    TagColor,
    ClaimsBlockSettlementAmount,
    Modal,
    customTooltip,
  },
  props: {
    claim: {
      type: Object,
      default: () => {},
    },
    expanded: {
      type: Array,
      default: () => [],
    },
    claimResolutions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    assignees: [],
    assignedCompany: {},
    note: '',
    claim_resolution_id: '',
    claimLoading: false,
    claimClose: false,
    showAssignClaim: false,
    visible: false,
    assigneeId: null,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    formInvalid() {
      return this.note.length === 0 && this.claim_resolution_id.length === 0;
    },
  },
  methods: {
    getClaim(claimMessage) {
      axios
        .get(`/claims/list/${this.claim.id}`)
        .then(res => {
          this.claim = res.data.data;
          toastr.success(claimMessage);
        })
        .finally(() => {
          this.claimLoading = false;
        });
    },
    assignClaim() {
      axios
        .get(`clusters/users/claims`)
        .then(res => {
          res.data.data.forEach(assignee => {
            assignee.name = `${assignee.first_name} ${assignee.last_name}`;
          });
          this.assignees = res.data.data;
          this.showAssignClaim = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    assign() {
      this.claimLoading = true;
      axios
        .patch(`claims/${this.claim.id}`, { cluster_user_id: this.assigneeId })
        .then(() => {
          this.getClaim('Successfully assigned claim');
          this.showAssignClaim = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    claimResolution() {
      this.claimLoading = true;
      axios
        .put(`/claims/${this.claim.id}/close`, {
          note: this.note,
          claim_resolution_id: this.claim_resolution_id,
        })
        .then(() => {
          this.getClaim('Claim updated successfully');
          this.claimClose = false;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    reopenClaim() {
      this.claimLoading = true;
      axios
        .put(`/claims/${this.claim.id}/`, {
          claim_resolution_id: null,
          claim_status_id: 2,
        })
        .then(() => {
          this.getClaim('Claim reopened successfully');
        });
    },
    copyToClipboard(refId, message) {
      this.$copyText(refId).then(() => toastr.success(message, '', { timeOut: 1000 }));
    },
    toggleClaim(id) {
      this.$emit('expanded', id);
    },
    view(event, id) {
      this.$router.push(`/claims/edit/${id}${this.q ? `?q=${encodeURIComponent(this.q)}` : ''}`);
    },
    viewInNewTab(event, id) {
      const routeData = this.$router.resolve({
        path: `/claims/edit/${id}`,
      });
      window.open(routeData.href, '_blank');
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  color: inherit !important;
  width: 100%;
  text-decoration: none;
}
a:hover {
  color: inherit !important;
  text-decoration: none !important;
}
.claim-closed {
  background-color: #2962ff;
  display: flex;
  color: #fff;
  border-radius: 4px;
  padding: 14px;
  height: 52px;
}
.reopen-ico {
  line-height: inherit;
}
.lds-ellipsis {
  display: flex;
  justify-content: center;
  height: 45px;
  padding-top: 11px;
}

.lds-ellipsis div {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 10px !important;
  background: #e3e3e3;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #e0e5ea;
  }
}
.price {
  max-width: 100px;
}
.wrap {
  min-height: 45px;
}
.copy-icon {
  left: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/ClaimBlock.vue